import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
export interface PageHeadingProps {
  /** Buttons on the heading's baseline, aligned right. Never printed. */
  actions?: React.ReactNode;
  className?: string;
  /** How wide the lede is allowed to run, in characters. */
  ledeWidth?: string;
  /** One or two sentences under the title. */
  lede?: React.ReactNode;
  /**
   * The title. Its accented word is set in brass italic, so pass a `<Trans t={t}>`
   * rather than a plain string whenever the design calls for one.
   */
  title: React.ReactNode;
}

/** The title block that opens every page. */
export const PageHeading = t0 => {
  const $ = _c(16);
  const {
    actions,
    className,
    lede,
    ledeWidth: t1,
    title
  } = t0;
  const ledeWidth = t1 === undefined ? "66ch" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex flex-wrap items-end justify-between gap-4", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h1 className="ptl-display m-0 text-[clamp(38px,4.6vw,58px)] leading-none">{title}</h1>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== lede || $[5] !== ledeWidth) {
    t4 = lede ? <p data-slot="page-lede" className="m-0 text-base leading-[1.55] text-muted-foreground" style={{
      maxWidth: ledeWidth
    }}>{lede}</p> : null;
    $[4] = lede;
    $[5] = ledeWidth;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex flex-col gap-2.5">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== actions) {
    t6 = actions ? <div className="flex flex-wrap gap-2.5 print:hidden">{actions}</div> : null;
    $[10] = actions;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t5 || $[14] !== t6) {
    t7 = <header className={t2}>{t5}{t6}</header>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};